import React from 'react';

import { sliderStyle, tipStyle } from './style';
import Slider, { createSliderWithTooltip, type SliderProps } from 'rc-slider';

import 'rc-slider/assets/index.css';

const SliderWithToolTip = createSliderWithTooltip(Slider);

interface IProps extends SliderProps {
  leftLimit: number;
  rightLimit: number;
  disableRailFill?: boolean;
  tipProps?: Partial<RCTooltip.RCTooltip.Props>;

  handleChange: (value: number) => void;
  handleFormat: (value: number) => string;
}

export class IntervalSlider extends React.Component<IProps, {}> {
  private ref: HTMLDivElement | null = null;

  public getRef = (): HTMLDivElement => {
    return this.ref!;
  };

  public setRef = (ref: HTMLDivElement) => {
    if (!this.ref) {
      this.ref = ref;
      this.forceUpdate();
    }
  };

  public render() {
    const {
      className,
      value,
      step,
      handleChange,
      leftLimit,
      rightLimit,
      tipProps,
      handleFormat,
      onAfterChange,
      disableRailFill,
      dots,
      railStyle,
      dotStyle,
      activeDotStyle,
      marks,
      disabled,
    } = this.props;

    const customTipProps = {
      visible: true,
      overlayClassName: `${tipStyle} ${tipProps?.overlayClassName || ''}`,
      placement: tipProps?.placement || 'bottom',
      getTooltipContainer: this.getRef,
    };

    return (
      <div ref={this.setRef}>
        {this.ref && (
          <SliderWithToolTip
            className={`${sliderStyle} ${className || ''}`}
            value={value}
            step={step}
            onChange={handleChange}
            min={leftLimit}
            max={rightLimit}
            tipProps={customTipProps}
            tipFormatter={handleFormat}
            onAfterChange={onAfterChange}
            included={!disableRailFill}
            dots={dots}
            railStyle={railStyle}
            dotStyle={dotStyle}
            activeDotStyle={activeDotStyle}
            marks={marks}
            disabled={disabled}
          />
        )}
      </div>
    );
  }
}
